<template>
  <div class="pad-cycle-filters">
    <el-button size="small" @click="dialogVisible = true">
      <i class="el-icon-s-grid"></i>
      Pad Cycle
    </el-button>

    <el-dialog
      title="Pad Cycle Lookup"
      :visible.sync="dialogVisible"
      :close-on-click-modal="true"
      width="600px"
    >
      <PadCycleLookUp />
      <PadCycleLookUpWithId v-if="showPadCycleIdFilter" />
    </el-dialog>
  </div>
</template>

<script>
import PadCycleLookUp from '@/components/pods/chartData/PadCycleLookUp'
import PadCycleLookUpWithId from '@/components/pods/chartData/PadCycleLookUpWithId'
export default {
  props: {
    showPadCycleIdFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  components: {
    PadCycleLookUp,
    PadCycleLookUpWithId
  }
}
</script>
